export class HealthSystemPaymentInformation {
  HealthSystemId:	number;
  CardNumber:	string;
  CardExpirationMMYY:	string;
  CardCode:	string;
  FirstName:	string;
  LastName:	string;
  Address:	string;
  City:	string;
  State:	string;
  Zip:	string;
}


export class CreditCardPaymentInformation{

  cardNumber:	string;
  cardExpirationMMYY:	string;
  cardCode:	string;
  firstName:	string;
  lastName:	string;
  address:	string;
  city:	string;
  state:	string;
  zip:	string;
  AuthorizeNetUserID: string;
}

export class HealthSystemPaymentInformationv2 extends CreditCardPaymentInformation {

  email:string;
  suscriptionCurrentAmount?: number;
  subscriptionStartDate?: Date;
  subscriptionStatus? :string
  authorizeNetProfileId: string;
  healthOrganizationId:	number;
  cardType:string;

}

